/**
 * @fileoverview Identity checks for buyer companies imported from Excel.
 * @module utils/excelCompanyMatch
 */

const sameRfc = (left, right) =>
  String(left ?? "")
    .trim()
    .toUpperCase() ===
  String(right ?? "")
    .trim()
    .toUpperCase();

/**
 * @param {object|null|undefined} existingCompany
 * @param {object|null|undefined} company
 * @returns {boolean}
 */
export const isSameBuyerCompanyIdentity = (existingCompany, company) =>
  existingCompany?.razonSocial === company?.razonSocial &&
  existingCompany?.nombreComercial === company?.nombreComercial &&
  sameRfc(existingCompany?.RFC, company?.rfc);

/**
 * @param {Array<object>} existingCompanies
 * @param {object} company
 * @returns {object|undefined}
 */
export const findExactBuyerCompany = (existingCompanies, company) =>
  (existingCompanies || []).find((existingCompany) =>
    isSameBuyerCompanyIdentity(existingCompany, company),
  );

/**
 * A company that shares one identity field but is not an exact match.
 * @param {Array<object>} existingCompanies
 * @param {object} company
 * @returns {object|undefined}
 */
export const findPartialBuyerCompany = (existingCompanies, company) =>
  (existingCompanies || []).find(
    (existingCompany) =>
      (existingCompany.razonSocial === company?.razonSocial ||
        existingCompany.nombreComercial === company?.nombreComercial ||
        sameRfc(existingCompany.RFC, company?.rfc)) &&
      !isSameBuyerCompanyIdentity(existingCompany, company),
  );
